import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { MinusIcon, PlusIcon } from "lucide-react";
export type MobileAccordionItem = {
  id: string;
  title: React.ReactNode;
  content: React.ReactNode;
};
type MobileAccordionProps = {
  items: MobileAccordionItem[];
  /** Index open on first render; null keeps everything closed. */
  defaultOpen?: number | null;
  className?: string;
};

/** Mobile-only (<768px) collapsible list. */
export function MobileAccordion({
  items,
  defaultOpen = 0,
  className = ""
}: MobileAccordionProps) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  const reduce = useReducedMotion();
  return <ul className={`border-t border-line md:hidden ${className}`} data-id="element-315" data-mp="3d1gsy9z8wkgg">
      {items.map((item, i) => {
      const isOpen = open === i;
      const panelId = `acc-${item.id}`;
      const Icon = isOpen ? MinusIcon : PlusIcon;
      return <li key={item.id} className="border-b border-line" data-id="element-316" data-mp="1bac2vicynry8" data-mpi={i}>
            <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[56px] w-full items-center justify-between gap-4 py-3 text-left font-ui text-[17px] font-bold leading-snug text-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-317" data-mp="1ij3exb62f7o5">
              {item.title}
              <Icon className="h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-318" data-mp="22ahv0x4i49hs" />
            </button>
            <AnimatePresence initial={false} data-id="element-319" data-mp="1sikinn1rbbhh">
              {isOpen && <motion.div id={panelId} initial={reduce ? false : {
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={reduce ? {
            opacity: 0
          } : {
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden" data-id="element-320" data-mp="1sg831gjh1d7l">
                  <div className="pb-5" data-id="element-321" data-mp="2zrccvrlwtkiz">{item.content}</div>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}